import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SetScoreboardViewModel } from '../../../../scoreboards/models/set-scoreboard.viewmodel';
import { ScoreboardComponentBase } from '../../../../scoreboards/scoreboard-base.component';

@Component({
    selector: 'ms-my-bets-scoreboard-set',
    templateUrl: 'my-bets-scoreboard-set.html',
    changeDetection: ChangeDetectionStrategy.Default,
})
export class MyBetsScoreboardSetComponent extends ScoreboardComponentBase {
    @Input() override vm: SetScoreboardViewModel;
}
